import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'selectedFileInfos']

  preventDefaultDrop(event) {
    event.preventDefault()
  }

  handleDrop(event) {
    event.preventDefault()

    const { files } = event.dataTransfer
    this.setSelectedFiles(files)
    this.displaySelectedFile(Array.from(files).shift())
  }

  openFileDialog() {
    this.inputTarget.click()
  }

  handleDialogSelect(event) {
    const { files } = event.target
    this.displaySelectedFile(Array.from(files).shift())
  }

  // private

  setSelectedFiles(files) {
    this.inputTarget.files = files
    this.inputTarget.dispatchEvent(new Event('change'))
  }

  displaySelectedFile(file) {
    if (typeof file === 'undefined') {
      return
    }

    this.selectedFileInfosTarget.innerText = file.name
  }
}
